import api from "./api";

const getAllByAccount = (accountId) => {
  return api.get("/api/customer-user/get-all-users", { params: { accountId } });
};

const assignLocations = (userId, customerIds) => {
  return api.post("/api/customer-user/assign-locations", { userId, customerIds });
};

const CustomerUserService = {
  getAllByAccount,
  assignLocations,
};

export default CustomerUserService;
